import { useCallback, useState } from 'react';

import { getRememberedPageValue, rememberPageValue } from './adminPlaceMemory';
import { getAdminUser } from './sectionAccess';

/**
 * Component-local tab state remembered per admin identity under a stable
 * scope. `allowedValues` must be a stable (module-level) array; stored values
 * outside it fall back to `fallback`.
 */
export const useRememberedTab = (scope, allowedValues, fallback) => {
  const [tab, setTab] = useState(() => getRememberedPageValue(
    scope, allowedValues, fallback, getAdminUser(),
  ));

  const selectTab = useCallback((value) => {
    if (!allowedValues.includes(value)) return;
    rememberPageValue(scope, value, allowedValues, getAdminUser());
    setTab(value);
  }, [allowedValues, scope]);

  return [tab, selectTab];
};

export default useRememberedTab;
